import { render, staticRenderFns } from "./ServiceText.vue?vue&type=template&id=803d6cc4&scoped=true"
import script from "./ServiceText.vue?vue&type=script&lang=js"
export * from "./ServiceText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803d6cc4",
  null
  
)

export default component.exports